import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { GenericStoreService } from '@common-modules/dynamic-layout/state/generic/generic-store.service';
import { ReduxStateModule } from '@common-modules/redux/redux-state.module';
import { DelegatePersistLayoutReduxService } from '../dynamic-layout-redux/delegate-persist-layout-redux.service';
import { DynamicLayoutReduxModule } from '../dynamic-layout-redux/dynamic-layout-redux.module';
import { StateReduxImplService } from './state-redux-impl.service';
import { StateService } from './state.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    DynamicLayoutReduxModule,
    ReduxStateModule.forFeature({
      storeServices: [GenericStoreService],
      sync: {
        syncKey: 'thin-client-store.dev',
      },
      delegatePersistLayout: {
        service: DelegatePersistLayoutReduxService,
      },
    }),
  ],
  exports: [ReduxStateModule],
})
export class StateModule {
  static forRoot(): ModuleWithProviders<StateModule> {
    return {
      ngModule: StateModule,
      providers: [
        {
          provide: StateService,
          useClass: StateReduxImplService,
        },
      ],
    };
  }

  static rootDependencies() {
    return ReduxStateModule.rootDependencies();
  }
}
